import {
  Box,
  Button,
  Center,
  Loader,
  Paper,
  Select,
  Text,
  Title,
  createStyles,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import axios from "axios";
import { useMedplum } from "@medplum/react";
import { useSelector } from "react-redux";
import { AppState } from "../../store/types/appState";
import { Buffer } from "buffer";
import {
  epicHandler,
  filterByValueString,
  getAccessToken,
  getTokenResponse,
} from "../../utils";
import { SelectItem, fetchPatientDetails, fetchPatientList } from "./clinicalNotesService";
import { getReferenceString } from "@medplum/core";
import { showNotification } from "@mantine/notifications";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg";
import { IAccumulator } from "../Appointment/AppointmentModal";
import { useDispatch } from "react-redux";
import GenericInfoModal from "../../components/GenericInfoModal";
import fetchResourceIcon from "../../assets/img/fetchingResourceLogo.svg";
import dbStoringIcon from "../../assets/img/storingDBLogo.svg";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    padding: "16px",
    marginTop: "16px",
  },
  heading: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  tite: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    marginBottom: "5px",
  },
  descrption: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    marginBottom: "5px",
  },
  textarea: {
    height: "168px",
    width: "100%",
    padding: "16px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    border: "1px solid #E5E5E5",
    outline: "none",
    resize: "none",
    borderRadius: "8px",
    wordBreak: "break-word",
  },
  input: {
    height: "50px",
    width: "100%",
    padding: "16px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    border: "1px solid #E5E5E5",
    outline: "none",
    borderRadius: "8px",
  },
  ButtonBox: {
    marginTop: "150px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "24px",
  },
  downloadLoader: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(0.5px)",
    zIndex: 9999,
  },
}));

interface Props {
  edit: Boolean;
  // patientId?:any
}

export const NewNote: React.FC<Props> = ({ edit, }) => {
  const medplum = useMedplum();
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const profile = medplum.getProfile();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [medplumId, setMedplumID] = useState(null);
  const [ispatientfetched, setisPateintFetched] = useState<boolean>(false);
  const [showInfoModal, setShowModal] = useState(false);

  const Navigate = useNavigate();
  const { id } = useParams();
  const [responseData, setResponseData] = useState<any>(null);
  const [selectedPatient, setSelectedPatient] = useState<any>([]);
  const [encounter, setEncounter] = useState<any>(null);
  const [isLoading, setIsloading] = useState<boolean>(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [htmlForClinicalNotes, setHtmlforClinicalNotes] = useState<string>();
  const [modalData, setModalData] = useState({
    title: "",
    sideTitle: "",
    details: [] as any,
    confirmText: "",
    onClose: () => {},
    onConfirm: () => {},
  });

  const [patientList, setPatientList] = useState<any>([]);

  useEffect(() => {
    checkTokenForEpic();

    getPatientList();
  }, []);
  const onEditorStateChange = (newEditorState: any) => {
    setEditorState(newEditorState);
  };
  let contentState = editorState.getCurrentContent();

  let plainText = contentState.getPlainText();
  const htmlConvertForClinicalNotes = draftToHtml(convertToRaw(contentState));

  const checkTokenForEpic = () => {
    const filteredData = filterByValueString(
      (logginedUser?.app?.profile?.extension as any) || [],
      "epic"
    );
    if (!filteredData?.length) {
      showNotification({
        color: "red",
        message: "Please connect with EPIC Provider",
        autoClose: true,
      });

      return;
    }
  };
  const modalSteps = [
    {
      loadText: "Creating clinical notes in EPIC EHR",
      label: "Creating clinical note in EPIC EHR",
      icon: fetchResourceIcon,
    },
    {
      loadText: "Clinical notes created successfully",
      label: "Clinical notes created successfully",
      icon: fetchResourceIcon,
    },
    {
      loadText: "Storing in HealthConnect",
      label: "Store in HealthConnect",
      icon: dbStoringIcon,
    },
  ];

  const logginedUser = useSelector((state: AppState) => state) as any;
  const statuss: any[] = logginedUser?.app?.profile?.extension || [];
  const epicObject = statuss.find((item) =>
    item.extension.some(
      (ext: any) => ext.url === "integrationType" && ext.valueString === "epic"
    )
  );
  const accessToken = epicObject
    ? epicObject.extension.find((ext: any) => ext.url === "access_token")
        ?.valueString
    : null;
  const epicDataFromExtension = filterByValueString(
    logginedUser?.app?.profile?.extension || ([] as any),
    "epic"
  );

  const getPatientList = async () => {
    setisPateintFetched(true);

    fetchPatientDetails(medplum, id)
      .then((patientListData:any) => {
      

        setPatientList(patientListData);
        setisPateintFetched(false);
      })
      .catch((error:any) => {
        // Handle errors if any occurred during fetching or processing
        console.error("Error fetching patient list:", error);
        setisPateintFetched(false);
      });
  };
  let createClinicalNotePayload = {
    eventType: "createClinicalNotes",
    EpicpatientId: patientList,
    medplumPatientId: id,
    Description: Buffer.from(htmlConvertForClinicalNotes).toString("base64"),
    title: title,
    accessToken:
      epicDataFromExtension[epicDataFromExtension?.length - 1]?.extension?.[0]
        ?.valueString || "",
  };

const createClinicalnotesFunction: () => Promise<any> = async () => {
  try {
    const activeLogin = getAccessToken();
    const result = epicDataFromExtension[
      epicDataFromExtension?.length - 1
    ]?.extension?.reduce((acc: IAccumulator, { url, valueString }) => {
      if (url === "refresh_token") {
        acc.refreshToken = valueString;
      } else if (url === "integrationType") {
        acc.integrationType = valueString;
      }else if (url === "display") {
        acc.name = valueString;
      }
      return acc;
    }, {});

    const clientId =
      epicDataFromExtension[epicDataFromExtension?.length - 1]?.url?.split(
        "/"
      )?.[1];

      const metaData = {
        dispatch,
        clientId: clientId,
        integrationType: result.integrationType,
        refreshToken: result.refreshToken,
        activeLogin,
        name: result.name
      }
    // setIsloading(true);
    const response = await epicHandler(medplum, createClinicalNotePayload, metaData);

    if (response.status === 200 || response.status === 201) {
      setIsloading(false);
    
      return response; // Return response here
    } else {
      setIsloading(false);
      setShowModal(false)
      showNotification({
        color: "red",
        message: `${response.body.message}`,
        autoClose: true,
      });
      return response; // Return response here
    }
  } catch (error: any) {
    setIsloading(false);
    if (error.status === 401) {
      showNotification({
        color: "red",
        message: `Unauthorized: ${error}`,
        autoClose: true,
      });
    }
    showNotification({
      color: "red",
      message: `An error occurred: ${error}`,
      autoClose: true,
    });
    setShowModal(false)
    return error; // Return error here
  }
};

const newClinicalNote = async () => {
  try {
    setShowModal(true); // Open the modal
    setModalData({
      title: " Please wait, we are creating New Clinical Note",
      sideTitle: "",
      details: [
        { label: "Title", text: title },
        { label: "Description", text: plainText },
      ],
      confirmText: "Proceed",
      onClose: () => {setShowModal(false)},
      onConfirm: async () => {
        await createClinicalnotesFunction().then((res)=>{
          if(res.status===201){
            setTimeout(() => {
                          Navigate(-1);
                  showNotification({
                    color: "green",
                    message: "success",
                    autoClose: true,
                  });
            }, 2100);
          }

        });
       
      },
    });
  } catch (error) {
    console.error(error);
  }
};


 

  const cancelClick = () => {
    Navigate(-1);
  };

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const isButtonDisabled =
    title === "" ||
    !selectedPatient ||
    editorState.getCurrentContent().hasText() === false;

  return (
    <>
      <Paper className={classes.default}>
        <Box>
          <Box>
            <CustomBreadcrumbs />
          </Box>
          <Box sx={{ paddingBottom: "24px", marginTop: "16px" }}>
            <Title className={classes.heading}>
              {edit ? "Edit clinical note" : "New clinical note"}
            </Title>
          </Box>
          <Box>
            <Box sx={{ marginBottom: "100px" }}>
              {/* <Box sx={{ marginBottom: "24px" }}>
                <Text className={classes.tite}>
                  Select Patient <span style={{ color: "red" }}>*</span>
                </Text>
                <Box
                  sx={{
                    height: "50px",
                    borderRadius: "5px",
                  }}
                >
                  {" "}
                  <Select
                    placeholder={
                      ispatientfetched
                        ? "Fetching patient list..."
                        : "Search Patients"
                    }
                    required={true}
                    data={patientList}
                    rightSection={
                      ispatientfetched ? <Loader size={"sm"} /> : ""
                    }
                    mt="lg"
                    size="lg"
                    radius="md"
                    value={selectedPatient}
                    onChange={(val) => {
                      setSelectedPatient(val);
                    }}
                    sx={{
                      ".mantine-Select-itemsWrapper": {
                        paddingRight: "10px",
                      },
                    }}
                    itemComponent={SelectItem}
                  />
                </Box>
              </Box> */}

              <Box sx={{ marginBottom: "24px" }}>
                <Text className={classes.tite}>
                  Title <span style={{ color: "red" }}>*</span>
                </Text>
                <Box
                  sx={{
                    height: "50px",
                    borderRadius: "5px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter title"
                    className={classes.input}
                    value={title}
                    onChange={handleTitleChange}
                  />
                </Box>
              </Box>

              <Box>
                <Text className={classes.descrption}>
                  Description <span style={{ color: "red" }}>*</span>
                </Text>
                <Box
                  sx={{
                    height: "168px",
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={
                      {
                        // height: "400px",
                        // overflowY: "auto",
                        // border: "1px solid #C9CDD3",
                        // borderRadius:"4px"
                      }
                    }
                  >
                    <Editor
                      defaultEditorState={editorState}
                      onEditorStateChange={onEditorStateChange}
                      placeholder="Notes Description"
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      editorStyle={{
                        border: "1px solid #C9CDD3",
                        borderRadius: "7px",
                        padding: "10px",
                        height: "200px",
                        overflow: "auto",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box className={classes.ButtonBox}>
              <Button
                variant="outline"
                sx={{ color: "#1C1C1C" }}
                onClick={cancelClick}
              >
                Cancel
              </Button>
              <Button
                variant="filled"
                // disabled={isButtonDisabled}
                onClick={newClinicalNote}
              >
                {edit ? "Save Changes" : "Create"}
              </Button>
            </Box>
          </Box>
        </Box>
        {isLoading && (
          <Center className={classes.downloadLoader}>
            <Loader />
          </Center>
        )}
        {showInfoModal && (
          <GenericInfoModal
            isOpen={showInfoModal}
            steps={modalSteps}
            modalData={modalData}
            onClose={modalData.onClose}
            onConfirm={modalData.onConfirm}
            setIsPatientModalOpen={setShowModal}
            showStepsImmediately={true}
            autoConfirm={true}
          />
        )}
      </Paper>
    </>
  );
};
